import { useState } from 'react'
import { useAuth } from './lib/auth'
import { supabase } from './lib/supabase'
import { Connexion } from './screens/Connexion'
import { Chantiers } from './screens/Chantiers'
import { Chantier } from './screens/Chantier'
import type { Chantier as TChantier } from './lib/types'

export function App() {
  const { session, profil, chargement } = useAuth()
  const [ouvert, setOuvert] = useState<TChantier | null>(null)
  const [cle, setCle] = useState(0)

  if (chargement) {
    return (
      <div className="app">
        <p className="vide" style={{ marginTop: 80 }}>Chargement…</p>
      </div>
    )
  }

  if (!session) return <Connexion />

  if (!profil) {
    return (
      <div className="app">
        <div className="corps">
          <p className="avis" style={{ marginTop: 40 }}>
            Ton compte existe, mais son profil n'a pas encore été créé en base. Préviens un
            administrateur.
          </p>
        </div>
      </div>
    )
  }

  if (ouvert) {
    return (
      <Chantier
        key={ouvert.id}
        chantier={ouvert}
        fermer={() => {
          setOuvert(null)
          setCle((k) => k + 1) // la liste se recharge en revenant
        }}
        recharger={async () => {
          // Relit le chantier sans le fermer : on reste sur l'onglet en cours.
          const { data } = await supabase.from('chantiers').select('*').eq('id', ouvert.id).single()
          if (data) setOuvert(data as TChantier)
        }}
      />
    )
  }

  return <Chantiers key={cle} ouvrir={setOuvert} />
}
